module.exports = __webpack_public_path__ + "static/media/bus-stop.a1c4bd44.svg";